/* eslint-env browser */

'use strict';

const asyncInitializer = require('../initializers/async_initializer');
const getBaseAsyncFiles = require('./base');

const init = (payload, done) => {
  const modulePromises = [
    ...getBaseAsyncFiles(payload),
    import(/* webpackChunkName: "g_map" */ './loaders/g_map'),
  ];

  if (payload.liveChat) {
    modulePromises.push(
      import(/* webpackChunkName: "live_chat" */ './loaders/live_chat')
    );
  }
  if (
    payload.loadSwitch &&
    payload.loadSwitch.shouldShowTipWidget &&
    payload.tipWidgetV2
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "tip_widget_v2" */ './loaders/tip_widget_v2')
    );
  }

  asyncInitializer(modulePromises, 40 * 1000, initStart => {
    if (
      typeof window.BOOMR !== 'undefined' &&
      typeof window.BOOMR.addVar === 'function'
    ) {
      window.BOOMR.addVar(
        'deal_page_async_modules_loaded',
        new Date() - initStart
      );
    }
  });

  return done();
};

module.exports = { init };
